/* Ozzi reviews. Progressive enhancement for snippets/ozzi-reviews.liquid.

   The first page of cards is server rendered, so this file is never the
   reason a review is missing. Everything here is additive: masonry spans,
   reveal, filters, sort, paging, the photo mosaic and the lightbox. With
   JavaScript off the visitor still gets 20 real reviews, the histogram, the
   attribute answers, the photo mosaic, the highlights, a working Write a
   review link and an honest count.

   The attribute numbers are server rendered from the ozzi.review_attributes
   metafield and are never touched here. They describe every published review
   for the product, not the page currently on screen, so a filter must not
   move them.

   Card markup built here is a byte-for-byte match of what the Liquid emits.
   If you change one, change the other.

   No dependencies. No scroll listeners. Vanilla, deferred.  */
(function () {
  'use strict';

  var PAGE_SIZE = 20;
  var CLAMP_LINES = 8;

  var ICON = {
    check:
      '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm3.9 6.2-4.6 4.6a.9.9 0 0 1-1.3 0L4.1 9a.9.9 0 1 1 1.3-1.3l1.3 1.3 4-4a.9.9 0 0 1 1.2 1.3Z"/></svg>',
    play:
      '<svg viewBox="0 0 64 64" fill="none" aria-hidden="true"><circle cx="32" cy="32" r="24" fill="rgba(255,255,255,.92)"/><path d="M27 22.5 43 32l-16 9.5V22.5Z" fill="#1C2B27"/></svg>',
    close:
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>',
    prev:
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 1 3 7l6 6"/></svg>',
    next:
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 1l6 6-6 6"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Shopify CDN files take a width parameter. Some already carry ?v=, so the
     separator has to be worked out rather than assumed. */
  function sized(url, w) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* media arrives as either a legacy array of URL strings or the current
     array of {url, kind} objects. Legacy strings are photos. */
  function normMedia(list) {
    if (!list || !list.length) return [];
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (typeof m === 'string') out.push({ url: m, kind: 'PHOTO', poster: '' });
      else if (m && m.url)
        out.push({
          url: m.url,
          kind: String(m.kind || 'PHOTO').toUpperCase() === 'VIDEO' ? 'VIDEO' : 'PHOTO',
          poster: m.poster || ''
        });
    }
    return out;
  }

  function starsHtml(rating, size) {
    var h =
      '<span class="oz-rv-rate' +
      (size ? ' oz-rv-rate--' + size : '') +
      '" role="img" aria-label="Rated ' +
      esc(rating) +
      ' out of 5"><span class="oz-rv-stars" aria-hidden="true">';
    for (var i = 0; i < 5; i++) {
      var f = Math.max(0, Math.min(100, Math.round((rating - i) * 1000) / 10));
      h += '<span class="oz-rv-star" style="--oz-f:' + f + '%"></span>';
    }
    return h + '</span></span>';
  }

  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        month: 'short',
        year: 'numeric'
      }).format(d);
    } catch (e) {
      return d.getFullYear();
    }
  }

  function mediaHtml(media, author) {
    if (!media.length) return '';
    var first = media[0];
    var isVideo = first.kind === 'VIDEO';
    var label = (isVideo ? 'Play video from ' : 'Open photo from ') + author + "'s review";
    var h =
      '<button type="button" class="oz-rv__media' +
      (isVideo && !first.poster ? ' oz-rv__media--novideo' : '') +
      '" data-oz-open="0" aria-label="' +
      esc(label) +
      '">';
    var src = isVideo ? first.poster : first.url;
    if (src) {
      h +=
        '<img src="' +
        esc(sized(src, 600)) +
        '" srcset="' +
        esc(sized(src, 400)) +
        ' 400w, ' +
        esc(sized(src, 600)) +
        ' 600w, ' +
        esc(sized(src, 900)) +
        ' 900w" sizes="(min-width:900px) 31vw, (min-width:600px) 46vw, 92vw"' +
        ' width="800" height="600" loading="lazy" decoding="async" alt="Photo from a customer review by ' +
        esc(author) +
        '">';
    }
    if (isVideo) h += '<span class="oz-rv__play">' + ICON.play + '</span>';
    if (media.length > 1)
      h += '<span class="oz-rv__media-more">+' + (media.length - 1) + '</span>';
    return h + '</button>';
  }

  function cardHtml(r, index, showProduct) {
    var media = normMedia(r.media);
    var body = esc(r.body || '').replace(/\r?\n/g, '<br>');
    var h =
      '<li class="oz-rv__card oz-rv--reveal" style="--oz-i:' +
      (index % 12) +
      '" data-oz-card data-oz-rid="' +
      esc(r.id) +
      '" data-oz-media="' +
      esc(JSON.stringify(media)) +
      '">';
    h += mediaHtml(media, r.author || 'a customer');
    h += '<div class="oz-rv__card-in">';
    h += '<div class="oz-rv__card-head">' + starsHtml(r.rating, 'sm');
    h +=
      '<time class="oz-rv__date" datetime="' +
      esc(String(r.date || '').slice(0, 10)) +
      '">' +
      esc(fmtDate(r.date)) +
      '</time></div>';
    h += '<p class="oz-rv__body">' + body + '</p>';
    h += '<p class="oz-rv__who"><span class="oz-rv__author">' + esc(r.author) + '</span>';
    if (r.verified)
      h += '<span class="oz-rv__verified">' + ICON.check + 'Verified buyer</span>';
    if (showProduct && r.productTitle)
      h += '<span class="oz-rv__product">' + esc(r.productTitle) + '</span>';
    h += '</p>';
    if (r.reply)
      h +=
        '<div class="oz-rv__reply"><p class="oz-rv__reply-who">Ozzi replied</p>' +
        '<p class="oz-rv__reply-text">' +
        esc(r.reply).replace(/\r?\n/g, '<br>') +
        '</p></div>';
    return h + '</div></li>';
  }

  function mount(root) {
    if (root.dataset.ozMounted) return;

    var grid = root.querySelector('[data-oz-grid]');
    var status = root.querySelector('[data-oz-status]');
    var foot = root.querySelector('[data-oz-foot]');
    var moreBtn = root.querySelector('[data-oz-more]');
    var pager = root.querySelector('[data-oz-pager]');
    var note = root.querySelector('[data-oz-note]');
    var sortSel = root.querySelector('[data-oz-sort]');
    var mediaBtn = root.querySelector('[data-oz-mediafilter]');
    var chip = root.querySelector('[data-oz-chip]');
    var chipText = root.querySelector('[data-oz-chip-text]');
    var hist = root.querySelector('[data-oz-hist]');
    var attrs = root.querySelector('[data-oz-attrs]');
    var mos = root.querySelector('[data-oz-mos]');
    /* Claimed only once there is something to enhance, so a root that is
       still empty can be mounted again when its markup arrives. */
    if (!grid) return;
    root.dataset.ozMounted = '1';

    /* The mosaic tiles point at reviews by id. Those cards are on the server
       rendered first page, but a filter or a page change replaces the grid,
       so the card the tile needs may no longer be in the document. Holding a
       reference to the original nodes keeps every tile working: a detached
       card still carries its media, its stars and its text, which is all the
       lightbox reads. */
    var firstPage = {};
    if (mos) {
      var seed = grid.querySelectorAll('[data-oz-card][data-oz-rid]');
      for (var s = 0; s < seed.length; s++) firstPage[seed[s].dataset.ozRid] = seed[s];
    }

    var api = root.dataset.api;
    var products = root.dataset.products || '';
    var showProduct = products.indexOf(',') > -1;
    var total = parseInt(root.dataset.total, 10) || 0;
    var totalAll = total;
    var shown = parseInt(root.dataset.show, 10) || PAGE_SIZE;
    var dist = {};
    try {
      dist = JSON.parse(root.dataset.distribution || '{}');
    } catch (e) {
      dist = {};
    }

    var state = {
      page: 1,
      rating: 0,
      mediaOnly: false,
      sort: 'featured',
      pages: 0,
      appended: true,
      touched: false
    };
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- masonry ---------- */
    var masonryReady = false;
    function rowSpan(card) {
      var cs = getComputedStyle(grid);
      var row = parseFloat(cs.getPropertyValue('grid-auto-rows')) || 8;
      var gap = parseFloat(cs.getPropertyValue('row-gap')) || 18;
      return Math.ceil((card.getBoundingClientRect().height + gap) / (row + gap));
    }
    function layout() {
      if (getComputedStyle(grid).gridTemplateColumns.split(' ').length < 2) {
        grid.classList.remove('is-masonry');
        var one = grid.children;
        for (var j = 0; j < one.length; j++) one[j].style.gridRowEnd = '';
        masonryReady = false;
        return;
      }
      grid.classList.add('is-masonry');
      masonryReady = true;
      var cards = grid.children;
      var spans = [];
      for (var i = 0; i < cards.length; i++) spans.push(rowSpan(cards[i]));
      for (var k = 0; k < cards.length; k++) cards[k].style.gridRowEnd = 'span ' + spans[k];
    }
    /* A tab that starts hidden (prerender, restored session, background
       load) never runs requestAnimationFrame, so the frame is only ever a
       way to coalesce bursts. The layout itself also runs straight away and
       again when the tab becomes visible. */
    var raf = 0;
    function relayout() {
      layout();
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(layout);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) relayout();
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(relayout);
      ro.observe(grid);
      root._ozRo = ro;
    }
    window.addEventListener('resize', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);

    /* ---------- clamp long bodies ---------- */
    function clamp(scope) {
      var bodies = scope.querySelectorAll('.oz-rv__body:not([data-oz-clamped])');
      var need = [];
      for (var i = 0; i < bodies.length; i++) {
        var b = bodies[i];
        b.setAttribute('data-oz-clamped', '1');
        var lh = parseFloat(getComputedStyle(b).lineHeight) || 23;
        if (b.scrollHeight > lh * CLAMP_LINES + 2) need.push(b);
      }
      for (var j = 0; j < need.length; j++) {
        var el = need[j];
        el.classList.add('is-clamped');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'oz-rv__expand';
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
        el.parentNode.insertBefore(btn, el.nextSibling);
      }
    }

    /* ---------- reveal ----------
       The hidden-before-reveal state only exists while data-oz-anim is set,
       and a safety timer clears the state for anything the observer has not
       reached. A hidden tab or a browser without IntersectionObserver still
       ends up showing every review. */
    var io = null;
    if (!reduced) root.setAttribute('data-oz-anim', '');
    if (!reduced && window.IntersectionObserver) {
      io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              entries[i].target.classList.add('is-in');
              io.unobserve(entries[i].target);
            }
          }
        },
        { rootMargin: '0px 0px -40px 0px' }
      );
    }
    function revealAll(scope) {
      var cards = scope.querySelectorAll('.oz-rv--reveal:not(.is-in)');
      for (var i = 0; i < cards.length; i++) cards[i].classList.add('is-in');
      if (hist) hist.classList.add('is-in');
    }
    function reveal(scope) {
      var cards = scope.querySelectorAll('.oz-rv--reveal:not(.is-in)');
      for (var i = 0; i < cards.length; i++) {
        if (io) io.observe(cards[i]);
        else cards[i].classList.add('is-in');
      }
      setTimeout(function () {
        revealAll(scope);
      }, 1400);
    }
    /* One shot reveal for a single element. The histogram bars and the
       attribute tracks both use it: each grows from nothing the first time it
       comes into view, and each is a shape the visitor is meant to read. */
    function revealOnce(el) {
      if (!el) return;
      if (reduced || !window.IntersectionObserver) {
        el.classList.add('is-in');
        return;
      }
      var o = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) {
          el.classList.add('is-in');
          o.disconnect();
        }
      });
      o.observe(el);
    }
    revealOnce(hist);
    revealOnce(attrs);

    /* ---------- status line. Always the honest number. ---------- */
    function setStatus(count, of, from) {
      if (!status) return;
      var noun = of === 1 ? 'review' : 'reviews';
      if (!of) status.textContent = 'Showing 0 reviews';
      else if (from)
        status.textContent = 'Showing ' + from + ' to ' + (from + count - 1) + ' of ' + of + ' ' + noun;
      else status.textContent = 'Showing ' + count + ' of ' + of + ' ' + noun;
    }

    function setNote(html) {
      if (!note) return;
      if (!html) {
        note.hidden = true;
        note.innerHTML = '';
        return;
      }
      note.innerHTML = html;
      note.hidden = false;
    }

    /* "5 stars" reads right on the chip, "5 star reviews" reads right in a
       sentence. Two forms rather than one awkward one. */
    function label(rating) {
      return rating === 1 ? '1 star' : rating + ' stars';
    }
    function labelAdj(rating) {
      return rating + ' star';
    }

    function syncChip() {
      if (!chip) return;
      if (!state.rating) {
        chip.hidden = true;
        return;
      }
      var n = dist[state.rating] != null ? dist[state.rating] : null;
      chipText.textContent = label(state.rating) + (n == null ? '' : ' · ' + n);
      chip.hidden = false;
    }

    function syncHist() {
      if (!hist) return;
      var rows = hist.querySelectorAll('[data-oz-rating]');
      for (var i = 0; i < rows.length; i++)
        rows[i].setAttribute(
          'aria-pressed',
          String(parseInt(rows[i].dataset.ozRating, 10) === state.rating)
        );
    }

    /* ---------- pager ---------- */
    function pageBtn(n, current) {
      return (
        '<button type="button" class="oz-rv__page" data-oz-page="' +
        n +
        '"' +
        (n === current ? ' aria-current="page"' : '') +
        ' aria-label="Page ' +
        n +
        '">' +
        n +
        '</button>'
      );
    }
    /* The pager stays out of the way until the visitor has asked for more
       than the first twenty, either with Read more or with a filter. */
    function renderPager() {
      if (!pager) return;
      if (state.pages < 2 || !state.touched) {
        pager.hidden = true;
        return;
      }
      var c = state.page,
        p = state.pages,
        h = '';
      h +=
        '<button type="button" class="oz-rv__page" data-oz-page="' +
        (c - 1) +
        '" aria-label="Previous page"' +
        (c === 1 ? ' disabled' : '') +
        '>' +
        ICON.prev +
        '</button>';
      var set = { 1: 1, 2: 1 };
      set[p] = 1;
      set[p - 1] = 1;
      set[c] = 1;
      set[c - 1] = 1;
      set[c + 1] = 1;
      var last = 0;
      for (var n = 1; n <= p; n++) {
        if (!set[n]) continue;
        if (last && n - last > 1) h += '<span class="oz-rv__gap" aria-hidden="true">…</span>';
        h += pageBtn(n, c);
        last = n;
      }
      h +=
        '<button type="button" class="oz-rv__page" data-oz-page="' +
        (c + 1) +
        '" aria-label="Next page"' +
        (c === p ? ' disabled' : '') +
        '>' +
        ICON.next +
        '</button>';
      pager.innerHTML = h;
      pager.hidden = false;
    }

    /* ---------- skeletons ---------- */
    function skeletons(n) {
      var h = '';
      for (var i = 0; i < n; i++)
        h += '<li class="oz-rv__card oz-rv__skeleton" style="min-height:' + (170 + (i % 3) * 60) + 'px"></li>';
      return h;
    }

    /* ---------- fetch ---------- */
    function query(page) {
      var q =
        api +
        '?product=' +
        encodeURIComponent(products) +
        '&page=' +
        page +
        '&pageSize=' +
        PAGE_SIZE +
        '&sort=' +
        encodeURIComponent(state.sort);
      if (state.rating) q += '&rating=' + state.rating;
      if (state.mediaOnly) q += '&media=1';
      return q;
    }

    /* Fallbacks for the day the v2 API has not landed yet. Sorting a page
       the server already sorted the same way is a no-op, so this is safe to
       leave in permanently. */
    function localSort(list) {
      var by = state.sort;
      if (by === 'featured') return list;
      return list.slice().sort(function (a, b) {
        if (by === 'highest' && a.rating !== b.rating) return b.rating - a.rating;
        if (by === 'lowest' && a.rating !== b.rating) return a.rating - b.rating;
        return new Date(b.date) - new Date(a.date);
      });
    }

    var inflight = 0;
    function load(page, append) {
      var token = ++inflight;
      state.appended = !!append;
      state.touched = true;
      state.lastPage = page;
      state.lastAppend = !!append;
      if (moreBtn) {
        moreBtn.disabled = true;
        moreBtn.textContent = 'Loading…';
      }
      if (!append) {
        grid.classList.add('is-busy');
        setNote('');
      }
      fetch(query(page), { headers: { accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (token !== inflight) return;
          render(data, page, append);
        })
        .catch(function () {
          if (token !== inflight) return;
          grid.classList.remove('is-busy');
          resetMoreBtn();
          setNote(
            'Those reviews did not load. <button type="button" class="oz-rv__note-cta" data-oz-retry>Try again</button>'
          );
        });
    }

    function resetMoreBtn() {
      if (!moreBtn) return;
      moreBtn.disabled = false;
      moreBtn.textContent = 'Read more reviews';
    }

    function render(data, page, append) {
      var list = localSort(data.reviews || []);
      var serverFiltersMedia = true;
      if (state.mediaOnly) {
        var withMedia = list.filter(function (r) {
          return normMedia(r.media).length;
        });
        serverFiltersMedia = withMedia.length === list.length;
        list = withMedia;
      }

      var of = data.total != null ? data.total : total;
      totalAll = data.totalAll != null ? data.totalAll : totalAll;
      if (data.distribution) dist = data.distribution;
      state.pages = data.pages || Math.max(1, Math.ceil(of / PAGE_SIZE));
      state.page = data.page || page;

      var start = append ? grid.children.length : 0;

      /* The server can render a page-one count that is not a whole API page,
         because the section setting is editable. Drop the overlap rather than
         skipping reviews, then drop anything already on screen by id in case
         the two orders disagree. */
      if (append) {
        var overlap = start % PAGE_SIZE;
        if (overlap) list = list.slice(overlap);
        list = list.filter(function (r) {
          return !grid.querySelector('[data-oz-rid="' + String(r.id).replace(/"/g, '') + '"]');
        });
      }

      var html = '';
      for (var i = 0; i < list.length; i++) html += cardHtml(list[i], start + i, showProduct);

      if (append) {
        grid.insertAdjacentHTML('beforeend', html);
        shown = grid.children.length;
        setStatus(shown, of);
      } else {
        grid.innerHTML = html;
        grid.classList.remove('is-busy');
        shown = list.length;
        if (state.page > 1) setStatus(shown, of, (state.page - 1) * PAGE_SIZE + 1);
        else setStatus(shown, of);
      }

      if (!list.length) {
        var what = state.rating ? labelAdj(state.rating) + ' reviews' : 'reviews';
        var extra = state.mediaOnly ? ' with photos or videos' : '';
        /* Only claim none exist when the server did the filtering. When the
           media filter fell back to the browser, all we honestly know is
           that this page had none. */
        var tail = serverFiltersMedia ? ' yet.' : ' on this page.';
        setNote(
          'No ' +
            esc(what) +
            extra +
            tail +
            ' <button type="button" class="oz-rv__note-cta" data-oz-clear>Clear the filters</button>'
        );
      } else {
        setNote('');
      }
      if (state.mediaOnly && !serverFiltersMedia && status)
        status.textContent = 'Showing ' + shown + ' reviews with photos or videos';

      clamp(grid);
      reveal(grid);
      relayout();
      syncChip();
      syncHist();
      renderPager();
      resetMoreBtn();
      if (moreBtn) moreBtn.hidden = state.page >= state.pages;
      if (foot) foot.hidden = state.pages < 2;
      if (!append && page > 1 && root.scrollIntoView) root.scrollIntoView({ block: 'start' });
    }

    function refilter() {
      grid.innerHTML = skeletons(6);
      grid.classList.remove('is-masonry');
      load(1, false);
    }

    /* ---------- lightbox ---------- */
    var lb = root.querySelector('[data-oz-lightbox]');
    var lbState = { items: [], i: 0, opener: null };

    function lbRender() {
      var m = lbState.items[lbState.i];
      if (!m) return;
      var stage = lb.querySelector('[data-oz-lb-stage]');
      var h = '';
      if (m.kind === 'VIDEO') {
        /* preload="none" plus controls: the file is only fetched when the
           visitor presses play. The #t=0.1 hint is on the source so the
           first frame lands as the still, and it costs nothing until then. */
        h =
          '<video controls playsinline preload="none"' +
          (m.poster ? ' poster="' + esc(sized(m.poster, 900)) + '"' : '') +
          ' src="' +
          esc(m.url + (m.poster ? '' : '#t=0.1')) +
          '"></video>';
      } else {
        h =
          '<img src="' +
          esc(sized(m.url, 1200)) +
          '" alt="Photo from a customer review" decoding="async">';
      }
      var many = lbState.items.length > 1;
      if (many) {
        h +=
          '<button type="button" class="oz-rv__lb-nav oz-rv__lb-nav--prev" data-oz-lb-prev aria-label="Previous item">' +
          ICON.prev +
          '</button>';
        h +=
          '<button type="button" class="oz-rv__lb-nav oz-rv__lb-nav--next" data-oz-lb-next aria-label="Next item">' +
          ICON.next +
          '</button>';
      }
      stage.innerHTML = h;
      var count = lb.querySelector('[data-oz-lb-count]');
      count.textContent = many ? lbState.i + 1 + ' of ' + lbState.items.length : '';
      count.hidden = !many;
    }

    function focusables() {
      return lb.querySelectorAll('button, [href], video, [tabindex]:not([tabindex="-1"])');
    }

    function lbOpen(card, index) {
      if (!lb) return;
      var items = [];
      try {
        items = normMedia(JSON.parse(card.dataset.ozMedia || '[]'));
      } catch (e) {
        items = [];
      }
      if (!items.length) return;
      lbState.items = items;
      lbState.i = index || 0;
      lbState.opener = document.activeElement;

      var head = lb.querySelector('[data-oz-lb-head]');
      var text = lb.querySelector('[data-oz-lb-text]');
      var stars = card.querySelector('.oz-rv-rate');
      var who = card.querySelector('.oz-rv__who');
      head.innerHTML = (stars ? stars.outerHTML : '') + (who ? who.outerHTML : '');
      var body = card.querySelector('.oz-rv__body');
      text.innerHTML = body ? body.innerHTML : '';

      lbRender();
      lb.hidden = false;
      root._ozScroll = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('[data-oz-lb-close]').focus();
    }

    function lbClose() {
      if (!lb || lb.hidden) return;
      lb.querySelector('[data-oz-lb-stage]').innerHTML = '';
      lb.hidden = true;
      document.documentElement.style.overflow = root._ozScroll || '';
      if (lbState.opener && lbState.opener.focus) lbState.opener.focus();
    }

    function lbStep(d) {
      var n = lbState.items.length;
      if (n < 2) return;
      lbState.i = (lbState.i + d + n) % n;
      lbRender();
    }

    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb) return lbClose();
        if (e.target.closest('[data-oz-lb-close]')) return lbClose();
        if (e.target.closest('[data-oz-lb-prev]')) return lbStep(-1);
        if (e.target.closest('[data-oz-lb-next]')) return lbStep(1);
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') return lbClose();
        if (e.key === 'ArrowLeft') return lbStep(-1);
        if (e.key === 'ArrowRight') return lbStep(1);
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0],
          last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;

      var open = t.closest('[data-oz-open]');
      if (open && grid.contains(open)) {
        e.preventDefault();
        return lbOpen(open.closest('[data-oz-card]'), parseInt(open.dataset.ozOpen, 10) || 0);
      }

      var tile = t.closest('[data-oz-mosaic]');
      if (tile) {
        e.preventDefault();
        var rid = tile.dataset.ozMosaic;
        var card =
          grid.querySelector('[data-oz-rid="' + String(rid).replace(/"/g, '') + '"]') ||
          firstPage[rid];
        if (card) return lbOpen(card, parseInt(tile.dataset.ozMi, 10) || 0);
        return;
      }

      var exp = t.closest('.oz-rv__expand');
      if (exp) {
        var body = exp.previousElementSibling;
        var open2 = body.classList.toggle('is-clamped');
        exp.textContent = open2 ? 'Read more' : 'Show less';
        exp.setAttribute('aria-expanded', String(!open2));
        relayout();
        return;
      }

      var row = t.closest('[data-oz-rating]');
      if (row) {
        var r = parseInt(row.dataset.ozRating, 10);
        state.rating = state.rating === r ? 0 : r;
        return refilter();
      }

      if (t.closest('[data-oz-chip-clear]')) {
        state.rating = 0;
        return refilter();
      }
      if (t.closest('[data-oz-clear]')) {
        state.rating = 0;
        state.mediaOnly = false;
        if (mediaBtn) mediaBtn.setAttribute('aria-pressed', 'false');
        return refilter();
      }
      if (t.closest('[data-oz-retry]')) return load(state.lastPage || 1, state.lastAppend);

      if (mediaBtn && t.closest('[data-oz-mediafilter]')) {
        state.mediaOnly = !state.mediaOnly;
        mediaBtn.setAttribute('aria-pressed', String(state.mediaOnly));
        return refilter();
      }

      if (moreBtn && t.closest('[data-oz-more]')) {
        /* Before the first fetch the only thing on screen is whatever Liquid
           rendered, so the next page comes from the count, not from a page
           number nobody has set yet. */
        var next = state.touched
          ? state.page + 1
          : Math.floor(grid.children.length / PAGE_SIZE) + 1;
        return load(next, true);
      }

      var pg = t.closest('[data-oz-page]');
      if (pg && !pg.disabled) {
        grid.innerHTML = skeletons(6);
        return load(parseInt(pg.dataset.ozPage, 10), false);
      }
    });

    if (sortSel)
      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        refilter();
      });

    /* ---------- first paint ---------- */
    clamp(grid);
    reveal(grid);
    relayout();
    if (foot) foot.hidden = shown >= total;
    if (moreBtn) moreBtn.hidden = shown >= total;
    setStatus(shown, total);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-oz-reviews]');
    for (var i = 0; i < roots.length; i++) mount(roots[i]);
  }

  window.OzReviews = { mount: mount, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
